export default {
    headerTitle: '360 Feedback Results',
    selfEvaluationTitle: 'Self-Assessment Results',
    employee: 'Employee',
    evaluation: 'Evaluation',
    reviewersInvited: 'Reviewers Invited',
    responded: 'Responded',
    noResponse: 'No Response',
    selfEvaluationPending:
        "{{firstName}} hasn't completed their self-assessment yet. Come back later to see the results.",
    selfEvaluationPendingUnnamed:
        "This employee hasn't completed their self-assessment yet. Come back later to see the results.",
    anonymousNote: "Respondents' names and photos are never shown.",
    completed: 'Completed',
    completedOn: 'Completed on {{date}}',
    belowThreshold: {
        closed: 'Closed',
        closedOn: 'Closed on {{date}}',
        waitingTitle_one: '{{count}} more response before results are shown',
        waitingTitle_other: '{{count}} more responses before results are shown',
        closedTitle: 'Results not available',
        received_one: '{{count}} response received of the {{minimum}} needed.',
        received_other: '{{count}} responses received of the {{minimum}} needed.',
        closedWith_one: 'Closed with {{count}} response of the {{minimum}} needed.',
        closedWith_other: 'Closed with {{count}} responses of the {{minimum}} needed.',
        closedOnWith_one: 'Closed on {{date}} with {{count}} response of the {{minimum}} needed.',
        closedOnWith_other:
            'Closed on {{date}} with {{count}} responses of the {{minimum}} needed.',
        explanation:
            "To protect respondents' anonymity, ratings and comments are shown only from {{minimum}} responses.",
        closedExplanation:
            "To protect respondents' anonymity, their ratings and comments will never be shown: at least {{minimum}} responses were needed.",
        closedNoResponseExplanation:
            'Nobody answered this 360 feedback before it closed: there are no results to show.',
        nextSteps: {
            title: 'What now?',
            launchNew: 'Launch a new 360 feedback',
            reopen: 'Reopen to invite more people',
            soon: 'Coming soon',
        },
    },
};
